import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CommonModal from '@/components-latest/shared/Modals/CommonModal';
import Button from '@/components-latest/primitives/Button';
import Text from '@/components-latest/primitives/Text';
import Styles from './OnlineRestriction.module.scss';

interface OnlineRestrictionProps {
  children: React.ReactNode;
  onClose: () => void; 
}

const OnlineRestriction: React.FC<OnlineRestrictionProps> = ({ children, onClose }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    onClose();
  };

  return (
    <>
      <CommonModal
        scrollableBody={false}
        className={Styles.modal}
        bodyClass={Styles.body}
        body={
          <div className={Styles.message}>
            <img
              className={Styles.imageForEmpty}
              src="/images/shop-cross-mark.svg"
              alt="Store temporarily closed"
            />
            <Text variant="title-3" gutter={8} className={Styles.title}>
              {t('store-temporarily-closed.title')}
            </Text>
            <Text variant="subtitle" className={Styles.dimmed}>
              {t('store-temporarily-closed.message')}
            </Text>
          </div>
        }
        footer={
          <Button
            variant="branded"
            size="small"
            onClick={handleCloseModal}
            className={Styles.button}
          >
            {t('store-temporarily-closed.button')}
          </Button>
        }
        open={isModalOpen}
        title=""
        onOpenChange={(isOpen) => setIsModalOpen(isOpen)}
      >
        {children}
      </CommonModal>
    </>
  );
};

export default OnlineRestriction;